<template>
  <ResetPassword />
</template>

<script>
import ResetPassword from "../../components/login/resetPassword";
export default {
  components: {
    ResetPassword,
  },
};
</script>
